import classNames from "classnames";
import { memo } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";
import * as css from "./chat-content-states.module.css";

interface GenericStateProps {
  title: string;
  subtitle?: string;
}

export const GenericConfirmedState = memo(function GenericConfirmedState({
  title,
  subtitle,
}: GenericStateProps) {
  return (
    <Flex
      bgColor="primary"
      borderColor="primary"
      borderStyle="solid"
      borderWidth="1px"
      className={classNames(css.stateContainer, css.messageSideLeft)}
      dir="column"
      gap="sm"
      maxW="full"
      px="lg"
      py="md"
      radius="sm"
      w="fit-content"
    >
      <Text fontSize="sm" fontWeight="semibold" textColor="primary">
        {title}
      </Text>
      {subtitle && (
        <Text fontSize="xs" textColor="secondary">
          {subtitle}
        </Text>
      )}
    </Flex>
  );
});

export const GenericRejectedState = memo(function GenericRejectedState({
  title = "Unable to complete request",
  subtitle = "Please try again or contact support for assistance",
}: GenericStateProps) {
  return (
    <Flex
      bgColor="primary"
      borderColor="primary"
      borderStyle="solid"
      borderWidth="1px"
      className={classNames(css.stateContainer, css.messageSideLeft)}
      dir="column"
      gap="sm"
      maxW="full"
      px="lg"
      py="md"
      radius="sm"
      w="fit-content"
    >
      <Text fontSize="sm" fontWeight="semibold" textColor="error">
        {title}
      </Text>
      <Text fontSize="xs" textColor="secondary">
        {subtitle}
      </Text>
    </Flex>
  );
});
